// Public Terms of Use page. Generic boilerplate suitable for a non-clinical
// demo deployment — replace with counsel-reviewed text before live use.

import LegalLayout from './LegalLayout.jsx';

export default function LegalTerms() {
  return (
    <LegalLayout title="Terms of Use" lastUpdated={LAST_UPDATED}>
      <p>
        These Terms of Use govern your access to and use of the {APP} platform
        ("Service"). By signing in or otherwise using the Service, you agree to
        these Terms. If you do not agree, do not use the Service.
      </p>

      <h2>1. Who can use the Service</h2>
      <p>
        The Service is intended for authorized hospital and pharmacy staff
        operating in the course of their duties. You must keep your credentials
        confidential and use the Service only for legitimate clinical and
        administrative purposes.
      </p>

      <h2>2. Acceptable use</h2>
      <ul>
        <li>Do not access patient information you do not need to perform your role.</li>
        <li>Do not share account credentials.</li>
        <li>Do not attempt to bypass security controls, scrape data, or reverse-engineer the Service.</li>
        <li>Do not use the Service to transmit unlawful, harassing, or harmful content.</li>
      </ul>

      <h2>3. Patient information &amp; HIPAA</h2>
      <p>
        Protected Health Information ("PHI") accessed through the Service is
        the property of your covered-entity employer and is regulated under
        HIPAA. The platform operator processes PHI only to provide the Service
        on behalf of your organization, under the terms of any applicable
        Business Associate Agreement.
      </p>

      <h2>4. Payments</h2>
      <p>
        Card data is collected and processed by Stripe, Inc. and never reaches
        the Service's servers. Payment processing is governed by Stripe's terms
        and applicable PCI-DSS rules. The Service handles only non-sensitive
        identifiers (last four digits, transaction IDs, processor status) and
        a record of patient consent.
      </p>

      <h2>5. Service availability</h2>
      <p>
        The Service is provided on an "as is" and "as available" basis. We do
        not warrant uninterrupted access. The Service is not a substitute for
        clinical judgment; do not rely on it as the sole source of truth for
        patient care decisions.
      </p>

      <h2>6. Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, the platform operator is not
        liable for indirect, incidental, special, or consequential damages, or
        for clinical decisions made by users.
      </p>

      <h2>7. Changes</h2>
      <p>
        We may update these Terms from time to time. Continued use after
        changes constitutes acceptance.
      </p>

      <h2>8. Contact</h2>
      <p>
        Questions about these Terms? Use the contact information on the
        <a href="/help/faq"> FAQ &amp; Help page</a>.
      </p>

      <p className="text-xs text-slate-500 mt-8">
        This document is generic boilerplate intended for demo deployments.
        Have qualified counsel review and replace before any production
        clinical use.
      </p>
    </LegalLayout>
  );
}

const APP = 'Meds-to-Beds';
const LAST_UPDATED = '2026-04-25';
